import React, { FunctionComponent } from 'react';
import { Route } from 'react-router-dom';
import routes from 'routes/products';

interface IProducts {}

const Products: FunctionComponent<IProducts> = () => {
  return (
    <>
      {routes.map(({ path, Component }, key) => (
        <Route exact path={path} key={key} component={Component} />
      ))}
    </>
  );
};

export default Products;
